import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { CustomerContext } from '../../../contexts/CustomerContext'
import useSchools from '../../../hooks/useSchools'
import Typography from '../../Typography'
import classes from './schedule-appointment.module.sass'
import Button from '../../Button'
import Cart from '../../../models/Cart'
import StudentIdForm from '../../StudentIdForm'
import ShootingSchedule from '../../../models/ShootingSchedule'
import { routes } from '../../../routes'
import { SchoolType } from '../../../models/_models'
import { useHistory } from 'react-router-dom'
import useQueryString from '../../../hooks/use-query-string'
import OtherSchoolTypeForm from './OtherSchoolTypeForm';
import { toast, ToastContainer } from 'react-toastify';
import apptHeaderImg from './make-appt-header.jpg';
import seniorApptHeaderImg from './senior-appt-header.jpg';
import Package from '../../../models/Package';
import { OrderPackage, Student } from '../../../models';
import SeniorCarousel from './SeniorCarousel';

const SCHEDULE_AT_SCHOOL = 'SCHEDULE_AT_SCHOOL'
const SCHEDULE_AT_SHOOB = 'SCHEDULE_AT_SHOOB'
const NO_SCHEDULES_AVAILABLE = 'NO_SCHEDULES_AVAILABLE'

export const customStyles = {
  control: (provided) => ({
    ...provided,
    border: '1px solid #aaa',
    borderRadius: 0,
    minHeight: 48,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};

const ScheduleAppointment = () => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()
  const { apptCart, currentSchool } = customer
  const schools = useSchools()
  const [school, setSchool] = useState('')
  const [email, setEmail] = useState(customer.email || '')
  const [studentId, setStudentId] = useState('');
  const [scheduleStatus, setScheduleStatus] = useState(SCHEDULE_AT_SCHOOL)
  const [step, setStep] = useState(0)
  const [schoolType, setSchoolType] = useState('')
  const { p: packageId, senior, message_id: messageId } = useQueryString()

  const apptText = senior ? 'Enter your information to view available appointments and schedule your Senior Portraits' : 'Enter your information to view available appointments for Studio Pictures';

  const [hasPackage, setHasPackage] = useState(true);
  const [apptPackage, setApptPackage] = useState();

  useEffect(() => {
    if (!school.value) return;
    /* should look for Fall E1 package for elementary */
    /* should look for appointment package / sittings for seniors */
    if (packageId) {
      Package
        .find(packageId)
        .then((res) => {
          if (!res) {
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }

          setApptPackage(res.data);
        });
    } else if (schoolType.toLowerCase().includes('elementary')) {
      Package
        .where({ schoolId: school.id, elementarySittings: true })
        .all()
        .then((res) => {
          if (res.data.length < 1) {
            console.log(school.id);
            console.log('elem');
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }

          setApptPackage(res.data[0]);
        });
    } else {
      Package
        .where({ schoolId: school.id, highSchoolSittings: true })
        .order({ shouldShowAppointments: false })
        .all()
        .then((res) => {
          if (res.data.length < 1) {
            console.log(school.id);
            console.log('hs');
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }

          setApptPackage(res.data[0]);
        });
    }
  }, [school]);

  useEffect(() => {
    async function getData() {
      if (!school) return

      const { data: schoolScheduleData } = await ShootingSchedule
        .where({ inFuture: true, schoolId: school.value })
        .all()

      const { data: shoobScheduleData } = await ShootingSchedule
        .where({ inFuture: true, schoolId: 1075 })
        .all()

      if (schoolScheduleData.length > 0) {
        setScheduleStatus(SCHEDULE_AT_SCHOOL)
      } else if (shoobScheduleData.length > 0) {
        setScheduleStatus(SCHEDULE_AT_SHOOB)
      } else {
        setScheduleStatus(NO_SCHEDULES_AVAILABLE)
      }
    }

    getData()
  }, [school])

  useEffect(() => {
    if (!school) return

    SchoolType
      .find(school.schoolTypeId)
      .then((res) => setSchoolType(res.data.name))
      console.log(schoolType);
  }, [school])

  let route
  if ([SCHEDULE_AT_SHOOB, NO_SCHEDULES_AVAILABLE].includes(scheduleStatus)) {
    const status = scheduleStatus === SCHEDULE_AT_SHOOB ? 0 : 1
    const t = schoolType.toLowerCase().includes('elementary') ? 0 : 1
    route = routes.scheduleAtShoob({ status, t, s: school.value, p: packageId })
  }

  const submitHandler = (e) => {
    e.preventDefault();

    if (!apptPackage) return;

    if (!school?.value) {
      toast.error('Please select your school.');
      return;
    }

    if (email === '') {
      toast.error('Please enter your email address');
      return;
    }

    if (studentId === '') {
      toast.error('Please enter a Student I.D. #');
      return;
    }

    //const gradeParam = senior ? { grade: 12 } : {};
    const gradeParam = {}; 

    console.log('Searching for student with:', { 
  schoolId: school.id, 
  studentId, 
  gradeParam 
});

    Student
      .where({ schoolId: school.id, studentId, isEnrolled: true, ...gradeParam })
      .first()
      .then((res) => {
        if (!res.data) {
          toast.error('We were unable to find your student with the given information. Please check back again at a later time', { autoClose: false });
          return;
        }

        toast.success('We found your student! Please wait while we redirect you to package options.', { autoClose: 10000 });

        const orderPackage = new OrderPackage({
          package: apptPackage,
          packageId: apptPackage.id,
          student: res.data,
          studentId: res.data.id,
        });

        if (apptCart) {
          apptCart.schoolId = school.id;
          apptCart.messageId = messageId;

          apptCart
            .save()
            .then(() => {
              orderPackage.cartId = apptCart.id;

              const selectedSchool = schools.find((sSchool) => sSchool.id === school.value);
              setCustomer({ ...customer, currentSchool: selectedSchool, currentStudent: res.data, email, currentOrderPackage: orderPackage });
              history.push(routes.appointmentOptionSelection(apptPackage.id));
            });
        } else {
          const selectedSchool = schools.find((sSchool) => sSchool.id === school.value)
          const cart = new Cart({
            createdLocation: 'sittings',
            email,
            school: selectedSchool,
            schoolId: school.value,
            messageId,
          });

          cart.save().then(() => {
            orderPackage.cartId = cart.id;

            setCustomer({
              ...customer, apptCart: cart, email, currentSchool: selectedSchool, currentStudent: res.data, currentOrderPackage: orderPackage
            });

            history.push(routes.appointmentOptionSelection(apptPackage.id));
          });
        }
      });
  };

  return (
    <>
      <div className={`${classes.pageContainer} ${classes.senior}`}>
        {!senior && <img className={`${classes.desktopImg} ${classes.img}`} src={apptHeaderImg} />}
        {senior && <img className={`${classes.desktopImg} ${classes.img}`} src={seniorApptHeaderImg} />}
        {senior && <img className={`${classes.mobileImg} ${classes.img}`} src={seniorApptHeaderImg} />}
        <ToastContainer position="bottom-right" />
        <div className={classes.container}>
          <div className={classes.seniorApptText}>
            <p>{senior ? 'Book Senior Session' : 'Make an Appointment'}</p>
            <p>{apptText}</p>
          </div>
          <div>
            {step === 1 && schoolType !== 'Other' && hasPackage && (
              <Typography classes={classes.instructions} align="center">
                To view available appointments, enter student I.D.
              </Typography>
            )}
            {step === 0 && (
              <form onSubmit={submitHandler} className={classes.form}>
                <label className={`${classes.label} ${classes.select}`}>
                  <span>Your School:</span>
                  <Select
                    styles={customStyles}
                    defaultValue={school}
                    options={schools.map((sSchool) => ({
                      value: sSchool.id,
                      label: sSchool.name,
                      schoolTypeId: sSchool.schoolTypeId,
                      id: sSchool.id
                    }))}
                    onChange={setSchool}
                  />
                </label>
                <label className={classes.label}>
                  <span>Your Email Address:</span>
                  <input type="email" placeholder="Email" value={email} onChange={(evt) => setEmail(evt.target.value)} />
                </label>
                <label className={classes.label}>
                  <span>Student I.D. #:</span>
                  <input type="text" placeholder="Student I.D." value={studentId}
                         onChange={(e) => setStudentId(e.target.value)} />
                </label>
                <Button fullWidth size="large" type="submit" variant="primary">Continue</Button>
              </form>
            )}
            {step === 1 && schoolType === 'Other' && <OtherSchoolTypeForm school={school} />}
            {step === 1 && schoolType !== 'Other' &&
              <StudentIdForm app isAppointments route={route} school={school} schoolType={schoolType}
                             setHasPackage={setHasPackage} />}
          </div>
        </div>
        {!senior && <img className={`${classes.mobileImg} ${classes.img}`} src={apptHeaderImg} />}
      </div>
      {senior && <SeniorCarousel />}
    </>
  )
}

export default ScheduleAppointment
